import { Home } from "./components/Home";
import { Tools } from "./components/Tools";
import { HalvingTable } from "./components/info/HalvingTable";
import { Privacy } from "./components/Privacy";

const AppRoutes = [
  {
    index: true,
    element: <Home />,
  },
  {
    path: '/tools',
    element: <Tools />
  },
  {
    path: '/privacy',
    element: <Privacy />
  },
  {
    path: '/info/halving',
    element: <HalvingTable />
  }
];

export default AppRoutes;
